import { render, staticRenderFns } from "./CapituloDos18Page.vue?vue&type=template&id=fe5767f8"
import script from "./CapituloDos18Page.js?vue&type=script&lang=js&external"
export * from "./CapituloDos18Page.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports